import { useMutation } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * ダウングレード予約の取り消し（BillingPage）。
 * 成功時は useDowngradeSubscription と同じく全体リロードで予約中の案内を消す。
 */
export function useCancelDowngrade() {
  return useMutation({
    mutationFn: () => billingApi.cancelDowngrade(),
    onSuccess: () => {
      window.location.reload()
    },
  })
}
